import React, { useEffect, useState, Fragment,useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import PaymentFilter from "components/sales/ListFilters/PaymentFilter";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Images from "assets/images/imageData";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import AdjustAdvancePopup from "components/sales/paymentPortal/adjustAdvance/adjustAdvancePopup";
import ViewDetailsPopup from "components/sales/paymentPortal/viewDetails/viewDetails";
import 'components/sales/layoutChange/layout.css';
import './vendorstyle.css';


const PaymentList = ({
  getVendorPaymentList,
  getVendorPaymentListSearch,
  dataList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
}) => {
  const headers = [
    "Vendor Code",
    "Firm Name",
    "Invoice Number",
    "Invoice Amount",
    "Requested Amount",
    "Status",
    "Requested Date",
    "Action"
    
  ];
  const [listData, setListData] = useState();
  const [isGoback, setIsGoback] = useState(1);
  const [activePostSales, setActivePostSales] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [searchKey,setSearchKey] = useState(null);
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const [showAdjustAdvancePopup, setShowAdjustAdvancePopup] = useState(false);
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [currentBusinessId, setCurrentBusinessId] = useState('');
  const [currentInvoiceId, setCurrentInvoiceId] = useState('');
  const [currentContractId, setCurrentContractId] = useState('');
  const [currentSiteNumber, setCurrentSiteNumber] = useState('');
  const [currentBusinessName, setCurrentBusinessName] = useState('');

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales("post-sales-corporate");
      } else if (teamId && teamId === 9) {
        setActivePostSales("post-sales-supply");
      } else if (teamId && teamId === 8) {
        setActivePostSales("post-sales-apartment");
      } else {
        setActivePostSales("post-sales-b2b-alliance");
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getVendorPaymentList !== null) {
      (async () => {
        setIsLoading(true);
        await getVendorPaymentList(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getVendorPaymentList]);

  useEffect(() => {
    const tableData = [
      "id",
      "vendor_code",
      "name_of_firm",
      "invoice_number",
      "total_amount",
      "request_amount",
      "status",
      "created_at"
    ];
    const actions1 = [
      { name: 'Payment Details', link: `${baseUrl}/vendorPaymentDetails` },
      { name: 'Add Request', link: `${baseUrl}/addPaymentRequest` },
    ];
    const actions = [
      { name: 'Payment Details', link: `${baseUrl}/vendorPaymentDetails` },
    ];

    if (dataList !== {} && dataList.data) {
      const data = dataList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: Number(element['total_amount']) > Number(element['request_amount']) ? actions1 : actions,
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(dataList.total / dataList.per_page));
    }
  }, [dataList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getVendorPaymentList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        {window.screen.width < 600?
        <>
          {/* <a
            href={`/dashboard/add_vendor_req`}
            className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
            >
              <img src={Images?.AddUser} alt=""  /> 
            </a>
          &nbsp; */}
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
          >
            <img src={Images?.FilterW} alt="" />
          </Button> 
        </>
        : 
          <>
           {/* <a
            href={`/dashboard/add_vendor_req`}
            className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
            >
              <img src={Images?.AddUser} alt=""  />  Add Vendor
            </a> */}
        
         <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
        >
          <img src={Images?.FilterW} alt="" />
          {localization.showFilters}
        </Button> 
        </>
        }
        
      </Fragment>
    );
  };

  const handleInputChange = (e) =>{
    setSearchKey(e.target.value);

  } 

  const applySearchKey = async () => {
    console.log(searchKey)
    setIsLoading(true);
    await getVendorPaymentListSearch(searchKey, 1);
    setIsLoading(false);
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getVendorPaymentList(filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.vendorPaymentList}
      // Buttons={headerBtns}
      isLoading={isLoading}
      searchOption={false}
    >
   
{/*         
          <div className="border border-primary rounded-10  searchBox" >
            <div className="input-group">
                  <input type="search" className="form-control rounded borderColorBox" onChange={e => handleInputChange(e)} placeholder="Search Vendor & Firm Name" aria-label="Search" aria-describedby="search-addon" />
                  <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={applySearchKey}>Search  </button>
                </div>
            </div>
        */}
    
     
      <div className="row table-margin">
        <div className="col-md-12">
     <TableSection
        data={listData}
        isId={false}
        detailList={dataList && dataList.data}
        headers={headers}
        pageCount={pageCount}
        srNo={dataList?.from}
        onPageChange={onPageChange}

      />
      </div>
      </div>
     <PaymentFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'5'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        siteFilters
      />

   </Layout>
  );
};

export default PaymentList;
